module.exports = __webpack_public_path__ + "static/media/alex-lose.b804591e.png";